/* eslint-disable @typescript-eslint/no-explicit-any */
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormProps, UseFormReturn } from 'react-hook-form';
import type { infer as zInfer, ZodType } from 'zod';

export default function useCustomForm<TSchema extends ZodType<any, any>>(
    schema: TSchema,
    defaultValues?: zInfer<TSchema> | null,
    config?: Omit<UseFormProps<zInfer<TSchema>>, 'defaultValues' | 'resolver'>
): UseFormReturn<zInfer<TSchema>> {
    const form = useForm<zInfer<TSchema>>({
        resolver: zodResolver(schema) as any,
        ...(defaultValues ? { defaultValues } : {}),
        ...config
    });

    return { ...form };
}

